import React from 'react';
import { Route } from 'react-router-dom';
import SimpleLoginCallback from "./simple-login-callback";

const prefix = '/simple-login';

const routes = [
  <Route 
    path={`${prefix}/callback`} 
    component={SimpleLoginCallback} 
    exact 
    key={`${prefix}-callback`} 
  />,
];

export default routes;